export const initialState = () => {
    return {
        managerStatusApi: {
            isProcessing: false,
            data: null,
            error: false,
        },
    }
};